import { render, staticRenderFns } from "./agradecimento.vue?vue&type=template&id=f81059a2&scoped=true"
import script from "./agradecimento.vue?vue&type=script&lang=js"
export * from "./agradecimento.vue?vue&type=script&lang=js"
import style0 from "./agradecimento.vue?vue&type=style&index=0&id=f81059a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81059a2",
  null
  
)

export default component.exports